export default [
    {
        path: '/teacher/question/question',
        name: '/teacher/question/question',
        component: () =>
            import ('../views/teacher/question/question.vue')
    },
    //协议--爱艺术家老师端
    {
        path: '/teacher/protocol/service',
        name: '/teacher/protocol/service',
        component: () =>
            import ('../views/teacher/protocol/service.vue')
    },
    {
        path: '/teacher/protocol/privacy',
        name: '/teacher/protocol/privacy',
        component: () =>
            import ('../views/teacher/protocol/privacy.vue')
    },
    {
        path: '/teacher/protocol/vip',
        name: '/teacher/protocol/vip',
        component: () =>
            import ('../views/teacher/protocol/vip.vue')
    },
    {
        path: '/teacher/protocol/buy',
        name: '/teacher/protocol/buy',
        component: () =>
            import ('../views/teacher/protocol/buy.vue')
    },
    {
        path: '/teacher/protocol/sdk',
        name: '/teacher/protocol/sdk',
        component: () =>
            import ('../views/teacher/protocol/sdk.vue')
    },
    {
        path: '/teacher/protocol/android_sdk',
        name: '/teacher/protocol/android_sdk',
        component: () =>
            import ('../views/teacher/protocol/android_sdk.vue')
    },
    {
        path: '/teacher/protocol/live',
        name: '/teacher/protocol/live',
        component: () =>
            import ('../views/teacher/protocol/live.vue')
    },
    {
        path: '/teacher/protocol/community',
        name: '/teacher/protocol/community',
        component: () =>
            import ('../views/teacher/protocol/community.vue')
    },
]